(function () {

    angular
        .module('smartertoolsApp')
        .controller('unpaidInvoicesController', ['$scope', '$log', '$timeout', 'invoices', 'cacheControl', 'notificationFactory', '$window', unpaidInvoicesController]);

    function unpaidInvoicesController($scope, $log, $timeout, invoices, cacheControl, notify, $window) {
        var vm = this;
        vm.filteredInvoices = [];
        vm.totalFilteredItems = vm.filteredInvoices ? vm.filteredInvoices.length : 0;
        vm.currentPage = 1;
        vm.dateOnServer = Date.now();
        vm.itemsPerPage = 10;
        vm.sortKey = 'DateGeneratedUtc';
        vm.totalAmount = 0;
        vm.countryList = geographicLocations.countries;
        vm.stateList = geographicLocations.statesByCountry;
        vm.generatingDownload = false;

        // Functions
        vm.sort = sort;
        vm.filter = filter;
        vm.selectInvoice = selectInvoice;
        vm.modalShowPage = modalShowPage;
        vm.refresh = refresh;
        vm.sendEmail = sendEmail;
        vm.modalPayInvoice = modalPayInvoice;
        vm.refreshInvoicesAndClosePayModal = refreshInvoicesAndClosePayModal;
        vm.downloadPdf = downloadPdf;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
            $scope.$on('cache-clear', () => refresh());
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        }

        function filter() {
            $timeout(() => {
                vm.totalFilteredItems = vm.filteredInvoices ? vm.filteredInvoices.length : 0;
            }, 10);
        }

        function selectInvoice(invoice) {
            vm.selectedInvoice = invoice;
            vm.modalPage = 'start';
            vm.isSending = false;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('unpaid-view-modal')).show();
        }

        function modalShowPage(mode) {
            vm.modalPage = mode;
            if (mode === 'email') {
                $timeout(() => {
                    document.getElementById('invoiceViewEmailSendAddr').focus();
                }, 100);
            }
        }

        function downloadPdf() {
            vm.generatingDownload = true;
            invoices.downloadPdf(vm.selectedInvoice.InvoiceNumber)
                .then((response) => {
                    window.location.href = response.DownloadUrl;
                    vm.generatingDownload = false;
                })
                .catch(() => {
                    notify.error('Unable to generate PDF', 'Error!');
                    vm.generatingDownload = false;
                });
        }

        function refresh() {
            $scope.accountCtrl.isLoading++;
            invoices.getInvoices()
                .then((invoices) => {
                    $scope.accountCtrl.isLoading--;
                    var newArr = [];
                    for (let i = 0; i < invoices.length; i++) {
                        const invoice = invoices[i];
                        if (invoice.ShowInDue)
                            newArr.push(invoice);
                    }
                    vm.unpaidInvoices = newArr;
                    vm.filter();

                    var total = 0;
                    for (let i = 0; i < vm.unpaidInvoices.length; i++) {
                        total += vm.unpaidInvoices[i].Total;
                    }
                    vm.totalAmount = total;
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading--;
                });
        }

        function sendEmail() {
            vm.isSending = true;
            invoices.sendInvoiceEmail(vm.selectedInvoice.InvoiceNumber, vm.emailToSend)
                .then(() => {
                    vm.isSending = false;
                    vm.modalShowPage('email-sent');
                })
                .catch(() => {
                    vm.isSending = false;
                    notify.error('There was a problem sending the email.');
                });
        }

        function modalPayInvoice() {
            vm.isSending = true;
            if (vm.selectedPaymentMethod.PaymentType === 'card') {
                invoices.payExistingCard(vm.selectedInvoice.InvoiceNumber, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            } else if (vm.selectedPaymentMethod.PaymentType === 'new') {
                invoices.payNewCard(vm.selectedInvoice.InvoiceNumber, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            }
        }

        function refreshInvoicesAndClosePayModal() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        }
    }

})();